import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import UserTable from '../../Components/Tables/UserTable';
import BusinessTable from '../../Components/Tables/BusinessTable';
import CategoryTable from '../../Components/Tables/CategoryTable';
import UserProfile from '../../Components/Profile/UserProfile';
import BusinessProfile from '../../Components/Profile/BusinessProfile';
import AgentTable from '../../Components/Tables/AgentTable';
import BookingTable from '../../Components/Tables/BookingTable';
import ReviewsTable from '../../Components/Tables/ReviewsTable';
import MainDashboard from '../../Components/Dashboard/MainDashboard';

const Home = () => {
  return (
    <div className="app-main">
      <Navbar />
      <div className="homepage-main">
        <Sidebar />
        <div className="property-main">
        <Routes>
           <Route path="/dashboard" element={<MainDashboard/>} />
           <Route path="/customers" element={<UserTable role="customer" />} />
           <Route path="/view/profile" element={<UserProfile />} />
           <Route path="/view/business" element={<BusinessProfile />} />
           <Route path="/providers" element={<UserTable role="provider" />} />
           <Route path="/categories" element={<CategoryTable />} />
           <Route path="/categories/:id" element={<CategoryTable />} />
           <Route path="/business/pending" element={<BusinessTable status="pending"/>} />
           <Route path="/business/approved" element={<BusinessTable status="approved"/>} />
           <Route path="/business/rejected" element={<BusinessTable status="rejected"/>} />
           <Route path="/agents" element={<AgentTable/>} />
           <Route path="/bookings" element={<BookingTable/>} />
           <Route path="/bookings/:name/:businessId" element={<BookingTable/>} />
           <Route path="/reviews" element={<ReviewsTable/>} />
           <Route path="/reviews/:name/:businessId" element={<ReviewsTable/>} />
       </Routes>
        </div>
      </div>
    </div>
  );
};

export default Home;
